import { Navigate, createBrowserRouter, RouterProvider } from 'react-router-dom';
import { RoutesEnum, AdminRoutesEnum, MeRoutesEnum } from 'src/shared/models/enums/routes.enum';
import { UserLayout } from 'src/shared/components/organisms/userLayout';
import { UnprotectedLayout } from 'src/shared/components/organisms/unprotectedLayout';
import { MemberLayout } from 'src/shared/components/organisms/memberLayout';
// Auth
import RequireMember from 'src/shared/routes/requireMember';
import RequireUser from 'src/shared/routes/requireUser';
import { SilentRenew } from 'src/modules/auth/pages/silentRenew';
import { Callback } from 'src/modules/auth/pages/callback';
import { Login } from 'src/modules/auth/pages/login';
import { LogoutPage } from 'src/modules/auth/pages/logout';
// Others
import { MembersListPage } from 'src/modules/member/pages/membersListPage';
import { SendingOrderOverviewPage } from 'src/modules/sending/pages/sendingOrderOverviewPage';
import EditSendingOrder from 'src/modules/sending/pages/sendingOrderEditPage';
import CreateSendingOrder from 'src/modules/sending/pages/sendingOrderCreatePage';
import { SendingOrderDetails } from 'src/modules/sending/pages/sendingOrderDetailsPage';
import { GiftsListPage } from 'src/modules/gift/pages/giftsListPage';
import { GiftsDetailPage } from 'src/modules/gift/pages/giftsDetailPage';
import { GroupMessageEmailPage } from 'src/modules/groupMessageEmail/pages/groupMessageEmailPage';
import { GroupMessageEmailOverviewPage } from 'src/modules/groupMessageEmail/pages/groupMessageEmailOverviewPage';
import { GroupMessageEmailUnsubscribedPage } from 'src/modules/groupMessageEmail/pages/groupMessageEmailUnsubscribedPage';
import CreateMemberGroupEmailPage from 'src/modules/groupMessageEmail/pages/groupMessageEmailCreatePage';
import GroupMessageEmailEditPage from 'src/modules/groupMessageEmail/pages/groupMessageEmailEditPage';
import { MemberDetailsPage } from 'src/modules/member/pages/memberDetailsPage';
import { InvoiceDashboardPage } from 'src/modules/invoice/pages/invoiceDashboardPage';
import { InvoiceOverviewPage } from 'src/modules/invoice/pages/invoiceOverviewPage';
import { InvoiceDetailsPage } from 'src/modules/invoice/pages/invoiceDetailsPage';
import { DashboardUser } from 'src/modules/dashboard/pages/dashboardUser';
import { MemberImportPage } from 'src/modules/member/pages/memberImport';
import { UserListPage } from 'src/modules/user/pages/userListPage';
import { DistrictListPage } from 'src/modules/district/pages/districtListPage';
import { AssociationListPage } from 'src/modules/associations/pages/associationListPage';
import { MemberUpdates } from 'src/modules/member/pages/memberUpdates';
import { InvoiceMissionOverviewPage } from 'src/modules/invoice/pages/invoiceMissionOverviewPage';
import { EventListPage } from 'src/modules/event/pages/eventListPage';
import { EventDetailsPage } from 'src/modules/event/pages/eventDetailsPage';
import { SupportInvoiceDataOverview } from 'src/modules/support/pages/supportInvoiceDataOverview';
import { SupportInstallCustomer } from 'src/modules/support/pages/supportInstallCustomer';
import { MembersPage } from 'src/modules/member/pages/membersPage';
import { MemberAdvancedSearchPage } from 'src/modules/member/pages/memberAdvancedSearchPage';
import { DonorsListPage } from 'src/modules/gift/pages/donorsListPage';
import { DonorsDetailPage } from 'src/modules/gift/pages/donorsDetailsPage';
import { PaymentTransactionsPage } from 'src/modules/invoice/pages/paymentTransationsPage'; // PaymentPage
import { PaymentAccountingPage } from 'src/modules/invoice/pages/paymentAccountingPage';
import { IncomingBankPaymentPage } from 'src/modules/invoice/pages/incomingBankPaymentPage';
import { MemberMeDetailsPage } from 'src/modules/member/pages-member/memberMeDetailsPage';
import { MemberAutogiroStatusOverviewPage } from 'src/modules/invoice/pages/memberAutogiroStatusOverviewPage';
import { ArticleRegisterPage } from 'src/modules/invoice/pages/articleRegisterPage';
import { ArticleCategoryPage } from 'src/modules/invoice/pages/articleCategoryPage';
import { OrganizationPage } from 'src/modules/organization/pages/organizationPage';
import { MemberStripeStatusOverviewPage } from 'src/modules/invoice/pages/memberStripeStatusOverviewPage';
import { MemberProfileLayout } from 'src/modules/memberProfile/components/memberProfileLayout';
import { MemberProfileGroupPage } from 'src/modules/memberProfile/pages/memberProfileGroupPage';
import { MemberProfileDetailPage } from 'src/modules/memberProfile/pages/memberProfileDetailPage';
import { FundraiserDetailPage } from 'src/modules/fundraiser/pages/fundraiserDetailPage';
import { FundraiserOverviewPage } from 'src/modules/fundraiser/pages/fundraiserOverviewPage';
import { DocumentArchiveOverviewPage } from 'src/modules/documentArchive/pages/documentArchiveOverviewPage';
import { StatisticsMemberCountPage } from 'src/modules/statistics/pages/statisticsMemberCountPage';
import { StatisticsAgeAndGenderDistributionPage } from 'src/modules/statistics/pages/statisticsAgeAndGenderDistributionPage';

// Open pages
import SignUpPage from 'src/modules/signup/pages/signup';
// Admin
import { AdminSendingOrderListPage } from 'src/modules/admin/sending-order/pages/adminSendingOrderListPage';
import { CustomerSettingsOverviewPage } from 'src/modules/admin/customersettings/pages/customerSettingsOverviewPage';
import { GroupMessageSmsPage } from 'src/modules/groupMessageEmail/pages/groupMessageSmsPage';
import { GroupMessageSmsOverviewPage } from 'src/modules/groupMessageEmail/pages/groupMessageSmsOverviewPage';
import { GroupMessageSmsUnsubscribedPage } from 'src/modules/groupMessageEmail/pages/groupMessageSmsUnsubscribedPage';
import { GroupMessageSmsCreatePage } from 'src/modules/groupMessageEmail/pages/groupMessageSmsCreatePage';
import GroupMessageSmsEditPage from 'src/modules/groupMessageEmail/pages/groupMessageSmsEditPage';
import { MyExportsPage } from 'src/modules/me/pages/myExportsPage';
import { DistrictPage } from 'src/modules/district/pages/districtPage';
import { DistrictDetailPage } from 'src/modules/district/pages/districtEditPage';
import { DistrictTitlePage } from 'src/modules/district/pages/districtTitlePage';
import { DistrictUsersPage } from 'src/modules/district/pages/districtUsersPage';
import { AssociationPage } from 'src/modules/associations/pages/associationPage';
import { AssociationUsersPage } from 'src/modules/associations/pages/associationUsersPage';
import { AssocationEditPage } from 'src/modules/associations/pages/associationEditPage';
import { MyDistrictPage } from 'src/modules/district/pages/myDistrictPage';
import { MyAssociationPage } from 'src/modules/associations/pages/myAssociationPage';
import { AssociationTitlePage } from 'src/modules/associations/pages/associationTitlePage';
import { EventCalendarPage } from 'src/modules/event/pages/eventCalendarPage';
import { EventsPage } from 'src/modules/event/pages/eventsPage';
import { EventMeCalendarPage } from 'src/modules/event/pages-me/eventMeCalendarPage';
import { EventMeDetailsPage } from 'src/modules/event/pages-me/eventMeDetailsPage';
import { DashboardMe } from 'src/modules/dashboard/pages/dashboardMe';
import { AssociationFeePage } from 'src/modules/associations/pages/associationFeePage';
import { InvoiceAddressPage } from 'src/modules/member/invoicerecipient/pages/invoiceAddressPage';
import { AutogiroCreateFileOverviewPage } from 'src/modules/invoice/pages/autogiroCreateFileOverviewPage';
import { AutogiroMandateOverviewPage } from 'src/modules/invoice/pages/autogiroMandateOverviewPage';
import { AutogiroPage } from 'src/modules/invoice/pages/autogiroPage';
import { EInvoicePage } from 'src/modules/invoice/pages/eInvoicePage';
import { EInvoiceReceiverOverviewPage } from 'src/modules/invoice/pages/eInvoiceReceiverOverviewPage';
import { EInvoiceApplicationsPage } from 'src/modules/invoice/pages/eInvoiceApplicationsPage';
import { EInvoiceAddressOverviewPage } from 'src/modules/invoice/pages/eInvoiceAddressOverviewPage';
import { EInvoiceLinkedOthersPage } from 'src/modules/invoice/pages/eInvoiceLinkedOthersPage';
import { WebFormsOverviewPage } from 'src/modules/webforms/pages/webFormsOverviewPage';
import { WebFormsDetailPage } from 'src/modules/webforms/pages/webFormsDetailPage';
import { StatisticsIncomeListPage } from 'src/modules/statistics/pages/statisticsIncomeListPage';
import { StatisticsMemberGrowthListPage } from 'src/modules/statistics/pages/statisticsMemberGrowthListPage';
import { StatisticsDashboardPage } from 'src/modules/statistics/pages/statisticsDashboardPage';
import { AdminInvoiceGroupDetailPage } from 'src/modules/admin/invoice/pages/adminInvoiceGroupDetailPage';
import { FortnoxCallbackPage } from 'src/modules/admin/invoice/pages/fortnoxCallbackPage';
import { AdminInvoiceGroupOverviewPage } from 'src/modules/admin/invoice/pages/adminInvoiceGroupOverviewPage';
import { MembersOtherContactPage } from 'src/modules/member/pages-othercontact-member/membersOtherContactPage';
import { AdminInvoiceTemplateOverviewPage } from 'src/modules/admin/invoice/pages/adminInvoiceTemplateOverviewPage';
import { InvoiceMissionDetailsPage } from 'src/modules/invoice/pages/invoiceMissionDetailsPage';
import { StatisticReportPage } from 'src/modules/statistics/pages/statisticReportPage';
import { StatisticsSnapshotPage } from 'src/modules/statistics/pages/statisticsSnapshotPage';
import { MemberSelectionPage } from 'src/modules/member/pages/memberSelectionPage';
import { MemberStripeCustomersOverviewPage } from 'src/modules/invoice/pages/memberStripeCustomersOverviewPage';
import { OrganizationFeePage } from 'src/modules/organization/pages/organizationFeePage';
import { OrganizationDetails } from 'src/modules/organization/components/organizationDetails';
import { OrganizationTitlePage } from 'src/modules/organization/pages/organizationTitlePage';
import { PaymentsOverviewPage } from 'src/modules/invoice/pages/paymentsOverviewPage';
import { FundraiserSettingsLayout } from 'src/modules/fundraiser/components/fundraiserSettingsLayout';
import { FundraiserSettingsOverviewPage } from 'src/modules/fundraiser/pages/fundraiserSettingsOverviewPage';
import { CustomerSettingsDetailPage } from 'src/modules/admin/customersettings/pages/customerSettingsDetailPage';
import { FundraiserSettingsEmailTextOverviewPage } from 'src/modules/fundraiser/pages/fundraiserSettingsEmailTextOverviewPage';
import { FundraiserSettingsDetailPage } from 'src/modules/fundraiser/pages/fundraiserSettingsDetailPage';
import { SettingsPage } from 'src/settings/pages/settingsPage';
import { AutojobSettingsPage } from 'src/settings/pages/autojobSettingsPage';
import { MemberRegistrySettingsPage } from 'src/settings/pages/memberRegistrySettingsPage';
import { DocumentCategoryOverviewPage } from 'src/modules/documentArchive/pages/documentCategoryOverviewPage';
import { StatisticsContextProvider } from '../contexts/statisticsContext';
import { OrganizationTitleTypeEnum } from '../models/enums/organizationTitleType.enum';

// import { AdminOverviewPage } from 'src/modules/admin/overview/pages/adminOverviewPage';

export const Routes = () => {
  const routes = createBrowserRouter([
    // OPEN ROUTES
    {
      element: <UnprotectedLayout />,
      children: [
        {
          path: RoutesEnum.Callback,
          element: <Callback />,
        },
        {
          path: RoutesEnum.SignUp,
          element: <SignUpPage />,
        },
        {
          path: RoutesEnum.SilentRenew,
          element: <SilentRenew />,
        },
        {
          path: RoutesEnum.Login,
          element: <Login />,
        },
        {
          path: RoutesEnum.Logout,
          element: <LogoutPage />,
        },
      ],
    },
    // USER ROUTES
    {
      element: (
        <RequireUser>
          <StatisticsContextProvider>
            <UserLayout />
          </StatisticsContextProvider>
        </RequireUser>
      ),
      children: [
        {
          path: RoutesEnum.Dashboard,
          element: <DashboardUser />,
        },
        {
          path: `${RoutesEnum.MyExports}`,
          element: <MyExportsPage />,
        },
        {
          element: <MembersOtherContactPage />,
          children: [
            {
              path: RoutesEnum.MemberOtherContact,
              element: <MembersListPage otherContactMode />,
            },
            {
              path: RoutesEnum.MemberOtherContactAdvancedSearch,
              element: <MemberAdvancedSearchPage otherContactMode />,
            },
          ],
        },
        {
          path: `${RoutesEnum.MemberOtherContactDetails}/:id`,
          element: <MemberDetailsPage otherContactMode />,
        },
        {
          element: <MembersPage />,
          children: [
            {
              path: RoutesEnum.Members,
              element: <MembersListPage otherContactMode={false} />,
            },
            {
              path: RoutesEnum.MemberAdvancedSearch,
              element: <MemberAdvancedSearchPage otherContactMode={false} />,
            },
            {
              path: RoutesEnum.MemberSelection,
              element: <MemberSelectionPage />,
            },
          ],
        },
        {
          path: `${RoutesEnum.MemberDetails}/:id`,
          element: <MemberDetailsPage otherContactMode={false} />,
        },
        {
          path: RoutesEnum.MemberUpdates,
          element: <MemberUpdates />,
        },
        {
          path: RoutesEnum.ImportMembers,
          element: <MemberImportPage />,
        },
        {
          path: RoutesEnum.MemberInvoiceAddress,
          element: <InvoiceAddressPage />,
        },
        {
          element: <GroupMessageEmailPage />,
          children: [
            {
              path: RoutesEnum.GroupMessageEmailOverview,
              element: <GroupMessageEmailOverviewPage />,
            },
            {
              path: RoutesEnum.GroupMessageEmailUnsubscribed,
              element: <GroupMessageEmailUnsubscribedPage />,
            },
          ],
        },
        {
          path: `${RoutesEnum.GroupMessageEmailCreateFromTemplate}/:id`,
          element: <CreateMemberGroupEmailPage />,
        },
        {
          path: `${RoutesEnum.GroupMessageEmailEdit}/:id`,
          element: <GroupMessageEmailEditPage />,
        },
        {
          element: <GroupMessageSmsPage />,
          children: [
            {
              path: RoutesEnum.GroupMessageSmsOverview,
              element: <GroupMessageSmsOverviewPage />,
            },
            {
              path: RoutesEnum.GroupMessageSmsUnsubscribed,
              element: <GroupMessageSmsUnsubscribedPage />,
            },
          ],
        },
        {
          path: RoutesEnum.GroupMessageSmsCreate,
          element: <GroupMessageSmsCreatePage />,
        },
        {
          path: `${RoutesEnum.GroupMessageSmsEdit}/:id`,
          element: <GroupMessageSmsEditPage />,
        },
        {
          path: RoutesEnum.Sending,
          element: <SendingOrderOverviewPage />,
        },
        {
          path: `${RoutesEnum.SendingOrderDetail}/:id`,
          element: <SendingOrderDetails />,
        },
        {
          path: `${RoutesEnum.EditSendingOrder}/:id`,
          element: <EditSendingOrder />,
        },
        {
          path: RoutesEnum.CreateSendingOrder,
          element: <CreateSendingOrder />,
        },
        {
          path: RoutesEnum.Fundraiser,
          element: <FundraiserOverviewPage />,
        },
        {
          path: `${RoutesEnum.FundraiserDetail}/:id`,
          element: <FundraiserDetailPage />,
        },
        {
          path: RoutesEnum.Gifts,
          element: <GiftsListPage />,
        },
        {
          path: `${RoutesEnum.GiftsDetail}/:id`,
          element: <GiftsDetailPage />,
        },
        {
          path: RoutesEnum.Donors,
          element: <DonorsListPage />,
        },
        {
          path: `${RoutesEnum.DonorsDetail}/:id`,
          element: <DonorsDetailPage />,
        },
        {
          path: RoutesEnum.InvoiceDashboard,
          element: <InvoiceDashboardPage />,
        },
        {
          path: RoutesEnum.Invoices,
          element: <InvoiceOverviewPage />,
        },
        {
          path: `${RoutesEnum.Invoices}/:id`,
          element: <InvoiceDetailsPage />,
        },
        {
          path: RoutesEnum.PaymentTransactions,
          element: <PaymentTransactionsPage />,
        },
        {
          path: RoutesEnum.IncomingBankPayment,
          element: <IncomingBankPaymentPage />,
        },
        {
          path: RoutesEnum.PaymentAccounting,
          element: <PaymentAccountingPage />,
        },
        {
          path: RoutesEnum.Payments,
          element: <PaymentsOverviewPage />,
        },
        {
          element: <AutogiroPage />,
          children: [
            {
              path: RoutesEnum.Autogiro,
              element: <AutogiroMandateOverviewPage />,
            },
            {
              path: RoutesEnum.AutogiroCreateFile,
              element: <AutogiroCreateFileOverviewPage />,
            },
            {
              path: RoutesEnum.Memberautogirostatus,
              element: <MemberAutogiroStatusOverviewPage />,
            },
          ],
        },
        {
          element: <EInvoicePage />,
          children: [
            {
              path: RoutesEnum.EInvoice,
              element: <EInvoiceReceiverOverviewPage />,
            },
            {
              path: RoutesEnum.EInvoiceLinkedMembers,
              element: <EInvoiceAddressOverviewPage />,
            },
            {
              path: RoutesEnum.EInvoiceLinkedOthers,
              element: <EInvoiceLinkedOthersPage />,
            },
            {
              path: RoutesEnum.EInvoiceApplications,
              element: <EInvoiceApplicationsPage />,
            },
          ],
        },

        {
          element: <EventsPage />,
          children: [
            {
              path: RoutesEnum.Events,
              element: <EventListPage />,
            },
            {
              path: RoutesEnum.EventsCalendar,
              element: <EventCalendarPage />,
            },
          ],
        },
        {
          path: `${RoutesEnum.Events}/:id`,
          element: <EventDetailsPage />,
        },
        {
          path: `${RoutesEnum.Statistics}`,
          element: <StatisticsDashboardPage />,
        },
        {
          path: `${RoutesEnum.StatisticsMemberProgress}`,
          element: <StatisticsMemberGrowthListPage />,
        },
        {
          path: `${RoutesEnum.StatisticsReports}`,
          element: <StatisticReportPage />,
        },
        {
          path: `${RoutesEnum.StatisticsReportsSnapshot}`,
          element: <StatisticsSnapshotPage />,
        },
        {
          path: `${RoutesEnum.StatisticsReportsMembers}`,
          element: <StatisticsMemberCountPage />,
        },
        {
          path: `${RoutesEnum.StatisticsAgeAndGenderDistribution}`,
          element: <StatisticsAgeAndGenderDistributionPage />,
        },
        {
          path: `${RoutesEnum.StatisticsIncome}`,
          element: <StatisticsIncomeListPage />,
        },
        {
          path: RoutesEnum.OrganizationDistricts,
          element: <DistrictListPage />,
        },
        {
          element: <OrganizationPage />,
          children: [
            {
              path: RoutesEnum.Organization,
              element: <OrganizationDetails />,
            },
            {
              path: RoutesEnum.OrganizationFee,
              element: <OrganizationFeePage />,
            },
            {
              path: RoutesEnum.OrganizationBoard,
              element: <OrganizationTitlePage titleType={OrganizationTitleTypeEnum.Styrelse} />,
            },
            {
              path: RoutesEnum.OrganizationRole,
              element: <OrganizationTitlePage titleType={OrganizationTitleTypeEnum.Förtroendevalda} />,
            },
          ],
        },
        {
          element: <DistrictPage />,
          children: [
            {
              path: `${RoutesEnum.OrganizationDistricts}/:id`,
              element: <DistrictDetailPage />,
            },
            {
              path: `${RoutesEnum.OrganizationDistricts}/:id/styrelse`,
              element: <DistrictTitlePage titleType={OrganizationTitleTypeEnum.Styrelse} />,
            },
            {
              path: `${RoutesEnum.OrganizationDistricts}/:id/fortroendevalda`,
              element: <DistrictTitlePage titleType={OrganizationTitleTypeEnum.Förtroendevalda} />,
            },
            {
              path: `${RoutesEnum.OrganizationDistricts}/:id/users`,
              element: <DistrictUsersPage />,
            },
          ],
        },
        {
          element: <MyDistrictPage />,
          children: [
            {
              path: `${RoutesEnum.OrganizationMyDistrict}/*`,
              element: <DistrictDetailPage />,
            },
            {
              path: `${RoutesEnum.OrganizationMyDistrict}/styrelse`,
              element: <DistrictTitlePage titleType={OrganizationTitleTypeEnum.Styrelse} />,
            },
            {
              path: `${RoutesEnum.OrganizationMyDistrict}/fortroendevalda`,
              element: <DistrictTitlePage titleType={OrganizationTitleTypeEnum.Förtroendevalda} />,
            },
            {
              path: `${RoutesEnum.OrganizationMyDistrict}/users`,
              element: <DistrictUsersPage />,
            },
          ],
        },
        {
          path: RoutesEnum.OrganizationAssocations,
          element: <AssociationListPage />,
        },
        {
          element: <AssociationPage />,
          children: [
            {
              path: `${RoutesEnum.OrganizationAssocations}/:id`,
              element: <AssocationEditPage />,
            },
            {
              path: `${RoutesEnum.OrganizationAssocations}/:id/avgift`,
              element: <AssociationFeePage />,
            },
            {
              path: `${RoutesEnum.OrganizationAssocations}/:id/styrelse`,
              element: <AssociationTitlePage titleType={OrganizationTitleTypeEnum.Styrelse} />,
            },
            {
              path: `${RoutesEnum.OrganizationAssocations}/:id/fortroendevalda`,
              element: <AssociationTitlePage titleType={OrganizationTitleTypeEnum.Förtroendevalda} />,
            },
            {
              path: `${RoutesEnum.OrganizationAssocations}/:id/users`,
              element: <AssociationUsersPage />,
            },
          ],
        },
        {
          element: <MyAssociationPage />,
          children: [
            {
              path: `${RoutesEnum.OrganizationMyAssociation}`,
              element: <AssocationEditPage />,
            },
            {
              path: `${RoutesEnum.OrganizationMyAssociation}/avgift`,
              element: <AssociationFeePage />,
            },
            {
              path: `${RoutesEnum.OrganizationMyAssociation}/styrelse`,
              element: <AssociationTitlePage titleType={OrganizationTitleTypeEnum.Styrelse} />,
            },
            {
              path: `${RoutesEnum.OrganizationMyAssociation}/fortroendevalda`,
              element: <AssociationTitlePage titleType={OrganizationTitleTypeEnum.Förtroendevalda} />,
            },
            {
              path: `${RoutesEnum.OrganizationMyAssociation}/users`,
              element: <AssociationUsersPage />,
            },
          ],
        },
        {
          path: RoutesEnum.Settings,
          element: <SettingsPage />,
        },
        {
          path: RoutesEnum.Users,
          element: <UserListPage />,
        },
        {
          path: RoutesEnum.Support,
          element: <SupportInvoiceDataOverview />,
        },
        {
          path: RoutesEnum.InstallCustomer,
          element: <SupportInstallCustomer />,
        },
        {
          path: RoutesEnum.InvoiceMission,
          element: <InvoiceMissionOverviewPage />,
        },
        {
          path: `${RoutesEnum.InvoiceMissionDetail}/:id`,
          element: <InvoiceMissionDetailsPage />,
        },
        {
          path: `${RoutesEnum.InvoiceMissionDetailSendingType}/:id/:sendingType`,
          element: <InvoiceMissionDetailsPage />,
        },
        {
          path: RoutesEnum.MemberStripeStatus,
          element: <MemberStripeStatusOverviewPage />,
        },
        {
          path: RoutesEnum.StripeCustomer,
          element: <MemberStripeCustomersOverviewPage />,
        },
        {
          path: RoutesEnum.InvoiceArticleRegister,
          element: <ArticleRegisterPage />,
        },
        {
          path: RoutesEnum.InvoiceArticleCategory,
          element: <ArticleCategoryPage />,
        },
        {
          path: RoutesEnum.DocumentArchiveOverview,
          element: <DocumentArchiveOverviewPage />,
        },
        {
          path: RoutesEnum.DocumentCategoryOverview,
          element: <DocumentCategoryOverviewPage />,
        },
        {
          path: AdminRoutesEnum.SendingOrders,
          element: <AdminSendingOrderListPage />,
        },
        {
          path: RoutesEnum.CustomerSettings,
          element: <CustomerSettingsOverviewPage />,
        },
        {
          path: `${RoutesEnum.CustomerSettings}/:id`,
          element: <CustomerSettingsDetailPage />,
        },
        // {
        //   path: RoutesEnum.MemberFees,
        //   element: <MemberFeesOverviewPage />,
        // },
        {
          element: <MemberProfileLayout />,
          children: [
            {
              path: RoutesEnum.MemberProfileGroup,
              element: <MemberProfileGroupPage />,
            },
          ],
        },
        {
          path: `${RoutesEnum.MemberProfileDetail}/:id`,
          element: <MemberProfileDetailPage />,
        },
        {
          path: RoutesEnum.AdminInvoiceGroupSettings,
          element: <AdminInvoiceGroupOverviewPage />,
        },
        {
          path: `${RoutesEnum.AdminInvoiceGroupSettings}/:id`,
          element: <AdminInvoiceGroupDetailPage />,
        },
        {
          path: `${RoutesEnum.AdminInvoiceGroupSettings}/:id/accounting`,
          element: <AdminInvoiceGroupDetailPage />,
        },
        {
          path: '/settings/integrations/fortnox/callback',
          element: <FortnoxCallbackPage />,
        },
        {
          path: RoutesEnum.AdminInvoiceTemplateSettings,
          element: <AdminInvoiceTemplateOverviewPage />,
        },
        {
          element: <FundraiserSettingsLayout />,
          children: [
            {
              path: RoutesEnum.FundraiserSettings,
              element: <FundraiserSettingsOverviewPage />,
            },
            {
              path: RoutesEnum.SettingsFundraiserSettings,
              element: <FundraiserSettingsEmailTextOverviewPage />,
            },
          ],
        },
        {
          path: `${RoutesEnum.FundraiserSettingsDetail}/:id`,
          element: <FundraiserSettingsDetailPage />,
        },
        {
          path: RoutesEnum.WebFormSettings,
          element: <WebFormsOverviewPage />,
        },
        {
          path: `${RoutesEnum.WebFormSettings}/:name`,
          element: <WebFormsDetailPage />,
        },
        {
          path: RoutesEnum.AutojobSettings,
          element: <AutojobSettingsPage />,
        },
        {
          path: RoutesEnum.MemberRegistrySettings,
          element: <MemberRegistrySettingsPage />,
        },
      ],
    },
    // MEMBER ROUTES
    {
      element: (
        <RequireMember>
          <MemberLayout />
        </RequireMember>
      ),
      children: [
        {
          path: MeRoutesEnum.MemberDashboard,
          element: <DashboardMe />,
        },
        {
          path: MeRoutesEnum.MemberMyPage,
          element: <MemberMeDetailsPage />,
        },
        {
          path: `${MeRoutesEnum.MemberEvents}/:id`,
          element: <EventMeDetailsPage />,
        },
        {
          path: MeRoutesEnum.MemberEvents,
          element: <EventMeCalendarPage />,
        },

        {
          path: '*',
          element: <Navigate to={MeRoutesEnum.MemberDashboard} replace />,
        },
      ],
    },
    // OM INGEN RUTT MATCHAR
    {
      path: '*',
      element: <Navigate to={RoutesEnum.Dashboard} replace />,
    },
  ]);
  return <RouterProvider router={routes} />;
};
